import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aa5d03d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "general" }
const _hoisted_4 = {
  key: 0,
  class: "modalMunicipios"
}
const _hoisted_5 = { class: "contenedorMunicipios" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, " Seleccione el Municipio ", -1))
const _hoisted_7 = { class: "contenidoMunicipios" }
const _hoisted_8 = { class: "contenidoMunicipios" }
const _hoisted_9 = { id: "municipios" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "MUNICIPIO"),
  /*#__PURE__*/_createElementVNode("th", null, "PROVINCIA"),
  /*#__PURE__*/_createElementVNode("th", null, "REGION")
], -1))
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { style: {"margin-top":"35px"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos Generales")
], -1))
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "grid" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "unap"
}, "NOMBRE:", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "municipio"
}, "MUNICIPIO:", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "provincia"
}, "PROVINCIA:", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "region"
}, "REGION:", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "telefono"
}, "TELEFONO:", -1))
const _hoisted_21 = ["disabled"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Guardar ")
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = ["disabled"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Actualizar ")
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Eliminar ")
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_Navbar),
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          (_ctx.cargando)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("img", {
                  class: "img",
                  src: 'https://cruzjiminian-assets-bucket.s3.amazonaws.com/webapp/images/logo.png'
                }, null, 8, _hoisted_2)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        (_ctx.showModalMunicipios)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("label", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (this.showModalMunicipioMethod())),
                  for: "btn-modal"
                }, "X"),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        id: "search",
                        type: "search",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                        class: "form-control",
                        placeholder: "Introduzca el nombre del municipio",
                        onKeypress: _cache[2] || (_cache[2] = ($event: any) => (_ctx.buscar()))
                      }, null, 544), [
                        [_vModelText, _ctx.search]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("table", _hoisted_9, [
                        _hoisted_10,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.municipiosFiltrados, (municipio, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: index,
                            onClick: ($event: any) => (_ctx.setMunicipio(municipio))
                          }, [
                            _createElementVNode("td", null, _toDisplayString(municipio.municipio), 1),
                            _createElementVNode("td", null, _toDisplayString(municipio.provincia), 1),
                            _createElementVNode("td", null, _toDisplayString(municipio.region), 1)
                          ], 8, _hoisted_11))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("form", null, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("h6", _hoisted_12, _toDisplayString(_ctx.encabezado), 1),
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", null, [
                  _hoisted_16,
                  _withDirectives(_createElementVNode("input", {
                    id: "unap",
                    type: "String",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.centro.unap) = $event)),
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.centro.unap]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_17,
                  _withDirectives(_createElementVNode("input", {
                    id: "municipio",
                    type: "String",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.centro.municipio) = $event)),
                    class: "form-control",
                    onFocus: _cache[5] || (_cache[5] = ($event: any) => (this.showModalMunicipioMethod()))
                  }, null, 544), [
                    [_vModelText, _ctx.centro.municipio]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_18,
                  _withDirectives(_createElementVNode("input", {
                    disabled: "",
                    id: "provincia",
                    type: "String",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.centro.provincia) = $event)),
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.centro.provincia]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_19,
                  _withDirectives(_createElementVNode("input", {
                    disabled: "",
                    id: "region",
                    type: "String",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.centro.region) = $event)),
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.centro.region]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_20,
                  _withDirectives(_createElementVNode("input", {
                    id: "telefono",
                    type: "String",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.centro.telefono) = $event)),
                    class: "form-control",
                    onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.defTelefono()))
                  }, null, 544), [
                    [_vModelText, _ctx.centro.telefono]
                  ])
                ])
              ])
            ]),
            (this.modoForm == 'add')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-primary",
                  onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.createCentro(true)), ["prevent"])),
                  disabled: 
                !_ctx.centro.municipio ||
                  !_ctx.centro.provincia ||
                  !_ctx.centro.region ||
                  !_ctx.centro.telefono ||
                  !_ctx.centro.unap
              
                }, _hoisted_24, 8, _hoisted_21))
              : _createCommentVNode("", true),
            (this.modoForm == 'show')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-success",
                  onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.createCentro(false)), ["prevent"])),
                  disabled: 
                !_ctx.centro.municipio ||
                  !_ctx.centro.provincia ||
                  !_ctx.centro.region ||
                  !_ctx.centro.telefono ||
                  !_ctx.centro.unap
              
                }, _hoisted_28, 8, _hoisted_25))
              : _createCommentVNode("", true),
            (_ctx.showDelete)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "btn btn-danger",
                  onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.handleDelete()), ["prevent"]))
                }, _hoisted_31))
              : _createCommentVNode("", true)
          ])
        ])
      ], 512), [
        [_vShow, !_ctx.cargando]
      ])
    ])
  ]))
}